module.exports = __webpack_public_path__ + "img/news1-2.4cacc12a.png";